import { ActionCreator } from 'redux';
import { ThunkAction, Dispatch } from '../../../../types/actions';
import { TBoardId } from '../../../../types/types';
import { listViewActionSet } from '../store/listView/actions/listViewActionSet';
import { collapsedGroupsSetAction } from '../store/listViewBoard/actions/collapsedGroupsSet';
import { setLocalStorageItem } from '../helpers/setLocalStorageItem';
import { IGetState } from '../../../../types/types';
import { groupsToggleGoogleAnalyticsEvents } from './googleAnalyticsEvents';

export const groupsExpand: ActionCreator<ThunkAction> = (
    boardId: TBoardId
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        dispatch(listViewActionSet(boardId, collapsedGroupsSetAction([])));
        dispatch(groupsToggleGoogleAnalyticsEvents(false));
        setLocalStorageItem(boardId);
    };
    return action;
};
